import { AppEntity, ContactPersonId } from '@app/icare/db/schema/common'
import { CostCarrierId } from '@app/icare/entities/costCarrier/schema/CostCarrier'
import { msg } from '@lingui/core/macro'
import { entityId } from '@pkg/db/schema'
import { defineEnum } from '@pkg/shared/utils/enum-builder'
import { z } from 'zod'
import { PatientRelation } from './PatientRelation'

export const PatientCostCarrierId = entityId('patientCostCarrier')

export type PatientCostCarrierIdType = typeof PatientCostCarrierId.Type

export const CostCarrierExemptionStatusEnum = defineEnum({
  not_required: msg`Nicht erforderlich`,
  required: msg`Erforderlich`,
})

export type CostCarrierExemptionStatusType = typeof CostCarrierExemptionStatusEnum.$.Type

export const PatientCostCarrierRelationSchema = PatientRelation.extend({
  id: PatientCostCarrierId.schema,
  toId: CostCarrierId.ref,
  ikNumber: z.coerce.string().nullish(),
  exemption: z
    .object({
      status: z
        .enum(CostCarrierExemptionStatusEnum.$.zodEnum())
        .nullish()
        .default(CostCarrierExemptionStatusEnum.required),
    })
    .nullish()
    .default({ status: CostCarrierExemptionStatusEnum.required }),
  serviceNumber: z.coerce.string().nullish(),
})

export type PatientCostCarrierRelation = z.infer<typeof PatientCostCarrierRelationSchema>

export const PatientCostCarrierContactPersonId = entityId('patientCostCarrierContactPerson')

export const PatientCostCarrierContactPersonSchema = AppEntity.extend({
  id: PatientCostCarrierContactPersonId.schema,
  ownerId: PatientCostCarrierId.ref,
  contactPersonId: ContactPersonId.ref,
})

export type PatientCostCarrierContactPerson = z.infer<typeof PatientCostCarrierContactPersonSchema>
